interface Stat {
  label: string;
  value: string;
  change: string;
  positive: boolean;
  icon: string;
  color: string;
}

const stats: Stat[] = [
  { label: "Total Orders", value: "6", change: "+3 this week", positive: true, icon: "ri-shopping-bag-line", color: "bg-orange-50 text-orange-500" },
  { label: "Revenue", value: "$366.87", change: "+12.4% vs last month", positive: true, icon: "ri-money-dollar-circle-line", color: "bg-green-50 text-green-500" },
  { label: "Pending Shipment", value: "3", change: "Needs action", positive: false, icon: "ri-time-line", color: "bg-yellow-50 text-yellow-500" },
  { label: "Influencer Sales", value: "4", change: "3 platforms", positive: true, icon: "ri-star-line", color: "bg-rose-50 text-rose-500" },
];

export default function DashboardStats() {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats.map((s) => (
        <div key={s.label} className="bg-white rounded-xl border border-gray-100 p-5">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${s.color}`}>
              <i className={`${s.icon} text-lg`} />
            </div>
            <span className={`text-xs font-medium ${s.positive ? "text-green-600" : "text-yellow-600"}`}>
              {s.change}
            </span>
          </div>
          <div className="text-2xl font-extrabold text-gray-900 mb-0.5">{s.value}</div>
          <div className="text-xs text-gray-500">{s.label}</div>
        </div>
      ))}
    </div>
  );
}
